<template>
    <div>
        <b-row>
            <b-col sm="12" md="4" xl="3" v-if="mostrarFiltroContrato">
                <b-form-group>
                    <label>Contrato</label>
                    <b-input-group>
                        <b-form-input type="text" placeholder="Digite o número do contrato" v-model="contrato"
                            v-mask="'###/####/AAAA'"></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4" xl="3" v-if="mostrarFiltroProcessoCliente">
                <b-form-group>
                    <label>Processo Cliente</label>
                    <b-input-group>
                        <b-form-input type="text" placeholder="Digite o número do processo cliente"
                            v-model="processoCliente"></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4" xl="3" v-if="mostrarFiltroProcesso">
                <b-form-group>
                    <label>Processo da requisição</label>
                    <b-input-group>
                        <b-form-input type="text" placeholder="Digite o número do processo da requisição"
                            v-model="processo"></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4" xl="3" v-if="mostrarFiltroDocumento">
                <b-form-group>
                    <label>Documento</label>
                    <b-input-group>
                        <b-form-input type="text" placeholder="Digite o número do documento"
                            v-model="documento"></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4" xl="3" v-if="mostrarFiltroComprometimento">
                <b-form-group>
                    <label>Comprometimento</label>
                    <b-input-group>
                        <b-form-input type="text" placeholder="Digite o número do comprometimento"
                            v-model="comprometimento" v-mask="'##########'"></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4" v-if="responsaveis">
                <b-form-group>
                    <label>Gestor/Solicitante</label>
                    <model-list-select :list="responsaveis" option-text="codNomeFuncionario"
                        option-value="codFuncionario" v-model="responsavel" placeholder="Selecione um responsável">
                    </model-list-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4" v-if="unidades && mostrarFiltroUnidade">
                <b-form-group>
                    <label>Unidade do Contrato</label>
                    <model-list-select :list="unidades" option-text="nomeCodCCusto" option-value="codCCusto"
                        v-model="unidade" placeholder="Selecione uma unidade">
                    </model-list-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4" v-if="fornecedores">
                <b-form-group>
                    <label>Fornecedor</label>
                    <model-list-select :list="fornecedores" option-text="nome" option-value="codFornecedor"
                        v-model="fornecedor" placeholder="Selecione um fornecedor">
                    </model-list-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3" v-if="mostrarFiltroDataMovimento">
                <b-form-group>
                    <label>Data do Movimento (DE)</label>
                    <date-picker v-model="dataMovimentoDe" :config="$datePickerOptions2"
                        v-mask="'##/##/####'"></date-picker>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3" v-if="mostrarFiltroDataMovimento">
                <b-form-group>
                    <label>Data do Movimento (ATÉ)</label>
                    <date-picker v-model="dataMovimentoAte" :config="$datePickerOptions2"
                        v-mask="'##/##/####'"></date-picker>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3" v-if="mostrarFiltroDatasInicioFim">
                <b-form-group>
                    <label>Data Início (DE)</label>
                    <date-picker v-model="dataInicioDe" :config="$datePickerOptions2"
                        v-mask="'##/##/####'"></date-picker>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3" v-if="mostrarFiltroDatasInicioFim && mostrarFiltroDatasFim">
                <b-form-group>
                    <label>Data Início (ATÉ)</label>
                    <date-picker v-model="dataInicioAte" :config="$datePickerOptions2"
                        v-mask="'##/##/####'"></date-picker>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3" v-if="mostrarFiltroDatasInicioFim && mostrarFiltroDatasFim">
                <b-form-group>
                    <label>Data Fim (DE)</label>
                    <date-picker v-model="dataFimDe" :config="$datePickerOptions2" v-mask="'##/##/####'"></date-picker>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3" v-if="mostrarFiltroDatasInicioFim">
                <b-form-group>
                    <label>Data Fim (ATÉ)</label>
                    <date-picker v-model="dataFimAte" :config="$datePickerOptions2" v-mask="'##/##/####'"
                        :class="{ 'is-invalid': dataFimAteInvalida }"></date-picker>
                    <div v-if="dataFimAteInvalida" class="invalid-feedback d-block">
                        {{ mensagemErroDataFimAte }}
                    </div>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="6" v-if="unidades && mostrarFiltroCentroCusto">
                <b-form-group>
                    <label>Centro de Custo</label>
                    <model-list-select :list="unidades" option-text="nomeCodCCusto" option-value="codCCusto"
                        v-model="centroCusto" placeholder="Selecione um centro de custo">
                    </model-list-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="4">
                <b-form-group>
                    <b-checkbox v-model="apenasAtivos" class="mt-4 pt-2">Apenas Contratos Ativos</b-checkbox>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { ModelListSelect } from 'vue-search-select'

export default {
    props: {
        responsaveis: {
            type: Array
        },
        unidades: {
            type: Array
        },
        fornecedores: {
            type: Array
        },
        tiposFiltros: {
            type: String
        }
    },

    data() {
        return {
            contrato: null,
            processoCliente: null,
            responsavel: { codFuncionario: null, codNomeFuncionario: 'TODOS' },
            unidade: { codCCusto: null, nomeCodCCusto: 'TODAS' },
            fornecedor: { codFornecedor: null, nome: 'TODOS' },
            centroCusto: { codCCusto: null, nomeCodCCusto: 'TODAS' },
            dataMovimentoDe: null,
            dataMovimentoAte: null,
            processo: null,
            documento: null,
            comprometimento: null,
            dataInicioDe: null,
            dataInicioAte: null,
            dataFimDe: null,
            dataFimAte: null,
            apenasAtivos: false
        }
    },

    components: {
        ModelListSelect
    },

    computed: {
        filtro() {
            let retorno = {
                contrato: this.contrato,
                processoCliente: this.processoCliente,
                responsavel: this.responsavel && this.responsavel.codFuncionario !== undefined
                    ? this.responsavel.codFuncionario
                    : null,
                unidade: this.unidade && this.unidade.codCCusto !== undefined
                    ? this.unidade.codCCusto
                    : null,
                fornecedor: this.fornecedor && this.fornecedor.codFornecedor !== undefined
                    ? this.fornecedor.codFornecedor
                    : null,
                centroCusto: this.centroCusto && this.centroCusto.codCCusto !== undefined
                    ? this.centroCusto.codCCusto
                    : null,
                dataMovimentoDe: this.dataMovimentoDe
                    ? this.$moment(this.dataMovimentoDe, 'DD/MM/YYYY').format(
                        'YYYY-MM-DD'
                    )
                    : null,
                dataMovimentoAte: this.dataMovimentoAte
                    ? this.$moment(this.dataMovimentoAte, 'DD/MM/YYYY').format(
                        'YYYY-MM-DD'
                    )
                    : null,
                processo: this.processo,
                documento: this.documento,
                comprometimento: this.comprometimento,
                dataInicioDe: this.dataInicioDe
                    ? this.$moment(this.dataInicioDe, 'DD/MM/YYYY').format(
                        'YYYY-MM-DD'
                    )
                    : null,
                dataInicioAte: this.dataInicioAte
                    ? this.$moment(this.dataInicioAte, 'DD/MM/YYYY').format(
                        'YYYY-MM-DD'
                    )
                    : null,
                dataFimDe: this.dataFimDe
                    ? this.$moment(this.dataFimDe, 'DD/MM/YYYY').format(
                        'YYYY-MM-DD'
                    )
                    : null,
                dataFimAte: this.dataFimAte
                    ? this.$moment(this.dataFimAte, 'DD/MM/YYYY').format(
                        'YYYY-MM-DD'
                    )
                    : null,
                apenasAtivos: this.apenasAtivos
            }
            return retorno
        },

        dataFimAteInvalida() {
            return (
                this.validarDataFimAteMenorQue(this.dataFimDe) ||
                this.validarDataFimAteMenorQue(this.dataInicioDe)
            )
        },

        mensagemErroDataFimAte() {
            if (this.validarDataFimAteMenorQue(this.dataFimDe)) {
                return 'Data Fim (ATÉ) não pode ser menor que Data Fim (DE)'
            }
            if (this.validarDataFimAteMenorQue(this.dataInicioDe)) {
                return 'Data Fim (ATÉ) não pode ser menor que Data Início (DE)'
            }
            return ''
        },

        errosValidacao() {
            const erros = {
                dataFimAte: {
                    temErro: this.dataFimAteInvalida,
                    mensagem: this.mensagemErroDataFimAte,
                    campo: 'dataFimAte',
                    tipo: 'validacao_data'
                }
            }

            return Object.keys(erros).reduce((acc, key) => {
                if (erros[key].temErro) {
                    acc[key] = erros[key]
                }
                return acc
            }, {})
        },

        temErros() {
            return Object.keys(this.errosValidacao).length > 0
        },

        mensagensErro() {
            return Object.values(this.errosValidacao).map(
                (erro) => erro.mensagem
            )
        },

        mostrarFiltroContrato() {
            if (this.tiposFiltros && this.tiposFiltros.includes('z')) {
                return true
            }
            return false
        },

        mostrarFiltroProcessoCliente() {
            if (this.tiposFiltros && this.tiposFiltros.includes('y')) {
                return true
            }
            return false
        },

        mostrarFiltroProcesso() {
            if (this.tiposFiltros && this.tiposFiltros.includes('p')) {
                return true
            }
            return false
        },

        mostrarFiltroDocumento() {
            if (this.tiposFiltros && this.tiposFiltros.includes('d')) {
                return true
            }
            return false
        },

        mostrarFiltroComprometimento() {
            if (this.tiposFiltros && this.tiposFiltros.includes('c')) {
                return true
            }
            return false
        },

        mostrarFiltroUnidade() {
            if (this.tiposFiltros && this.tiposFiltros.includes('u')) {
                return true
            }
            return false
        },

        mostrarFiltroDataMovimento() {
            if (this.tiposFiltros && this.tiposFiltros.includes('m')) {
                return true
            }
            return false
        },

        mostrarFiltroDatasInicioFim() {
            if (this.tiposFiltros && this.tiposFiltros.includes('i')) {
                return true
            }
            return false
        },

        mostrarFiltroDatasFim() {
            if (this.tiposFiltros && !this.tiposFiltros.includes('g')) {
                return true
            }
            return false
        },

        mostrarFiltroApenasAtivos() {
            if (this.tiposFiltros && this.tiposFiltros.includes('a')) {
                return true
            }
            return false
        },

        mostrarFiltroCentroCusto() {
            if (this.tiposFiltros && this.tiposFiltros.includes('t')) {
                return true
            }
            return false
        }
    },

    methods: {
        validarDataFimAteMenorQue(dataReferencia) {
            if (!this.dataFimAte || !dataReferencia) {
                return false
            }
            const dataFimAte = this.$moment(this.dataFimAte, 'DD/MM/YYYY')
            const dataRef = this.$moment(dataReferencia, 'DD/MM/YYYY')
            return dataRef.isAfter(dataFimAte)
        }
    },

    watch: {
        contrato() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        processoCliente() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        responsavel() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        unidade() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        fornecedor() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        centroCusto() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        dataMovimentoDe() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        dataMovimentoAte() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        processo() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        documento() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        comprometimento() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        dataInicioDe() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        dataInicioAte() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        dataFimDe() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        dataFimAte() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        apenasAtivos() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        errosValidacao: {
            handler(novosErros) {
                this.$emit('errosValidacao', {
                    temErros: this.temErros,
                    erros: novosErros,
                    mensagens: this.mensagensErro
                })
            },
            deep: true,
            immediate: true
        }
    }
}
</script>
